export const COMMON_PALETTE = {
  primary: {
    cold: "#42A5F5",
    light: "#3e7aff",
    main: "#0050FF",
    dark: "#21304A",
    contrastText: "#fff"
  },
  secondary: {
    light: "rgba(0,79,265,0.6)",
    main: "rgba(0,79,265,0.8)",
    dark: "#004FFF",
    contrastText: "#fff"
  },
  contrast: {
    light: "#eaecf0",
    main: "#F0F1F4",
    text: "#0A2267",
    contrastText: "#0A2267"
  },
  text: {
    primary: "#0A2267",
    secondary: "#798193" //grey
  },
  error: {
    cold: "#DC004E",
    light: "#e57373",
    main: "#f44336",
    dark: "#d32f2f",
    contrastText: "#fff"
  },
  success: {
    main: "#4caf50",
    contrastText: "#fff"
  },
  dialogues: {
    customer: {
      background: "#EAECF0",
      text: "#0A2267",
      borderRadius: 10
    },
    expert: {
      background: "#D3E1FF",
      text: "#0A2267",
      borderRadius: 10
    },
    expiry: {
      background: "#616161",
      text: "#fafafa",
      borderRadius: 10
    },
    system: {
      background: "#616161",
      text: "#fafafa",
      borderRadius: 4
    },
    thirdParty: {
      background: "#E0F6FA",
      text: "#0A2267",
      borderRadius: 6
    }
  },
  star: {
    fill: "#FFB300",
    border: "#D7D7D7"
  },
  smiley: {
    fill: "#f5f5f5",
    border: "1px solid rgba(163,168,168, 0.5)",
    borderRadius: 4
  },
  grey: {
    4: "#303030"
  }
};